import type { RiskLevelOption } from '@/hooks/useRiskLevelsData';

/**
 * Mock risk levels data for demo mode
 */
export const mockRiskLevels: RiskLevelOption[] = [
  { id: 1, code: 'low', name: 'Low', sortOrder: 1 },
  { id: 2, code: 'medium', name: 'Medium', sortOrder: 2 },
  { id: 3, code: 'high', name: 'High', sortOrder: 3 },
  { id: 4, code: 'critical', name: 'Critical', sortOrder: 4 },
];
